import { createAction } from '@reduxjs/toolkit';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import type {
  DataLayer, DataLayerData, DataLayerId,
  DataLayerSettings,
} from './mapSettingsDataLayers.state';

export const mapSettingsDataLayersAddDataLayer = createAction(
  'MAP_SETTINGS_DATA_LAYERS_ADD_DATA_LAYER',
  (dataLayer: DataLayer) => ({
    payload: { dataLayer },
  })
);

export const mapSettingsDataLayersRemoveDataLayer = createAction(
  'MAP_SETTINGS_DATA_LAYERS_REMOVE_DATA_LAYER',
  (dataLayer: DataLayer) => ({
    payload: { dataLayer },
  })
);

export const mapSettingsDataLayersUpdateDataLayer = createAction(
  'MAP_SETTINGS_DATA_LAYERS_UPDATE_DATA_LAYER',
  ({ id, data, settings, fromTemplate }: {
    id: DataLayerId;
    data?: DataLayerData;
    settings?: DataLayerSettings;
    fromTemplate?: DataLayer['fromTemplate'];
  }) => ({
    payload: { id, data, settings, fromTemplate },
  })
);

export const mapSettingsDataLayersUpdateBoundaryGroup = createAction(
  'MAP_SETTINGS_DATA_LAYERS_UPDATE_BOUNDARY_GROUP',
  (dataLayerId: DataLayerId, boundaryGroupId: BoundaryGroupId) => ({
    payload: { dataLayerId, boundaryGroupId },
  })
);
